<script lang="ts">
	import imageRobotXs from "@assets/images/about-us-robot.jpg?webp&h=720&imagetools";
	import imageRobotSm from "@assets/images/about-us-robot.jpg?webp&h=800&imagetools";
	import imageRobotMd from "@assets/images/about-us-robot.jpg?webp&h=880&imagetools";
	import imageRobotLg from "@assets/images/about-us-robot.jpg?webp&h=960&imagetools";
	import imageRobotXl from "@assets/images/about-us-robot.jpg?webp&h=1680&imagetools";
	import imageRobot2Xl from "@assets/images/about-us-robot.jpg?webp&imagetools";
	import { ButtonSize } from "@components/common/ButtonSize.js";
	import { ButtonVariant } from "@components/common/ButtonVariant.js";
	import Formatted from "@components/common/Formatted.svelte";
	import Link from "@components/common/Link.svelte";
	import Media from "@components/common/Media.svelte";
	import { getTranslate } from "@utils/getTranslate.js";
	import { CategoryType } from "@core/schema/CategoryType.js";
	import { getCategoryPath } from "@core/schema/paths/getCategoryPath.js";
	import { getGlobalTemplateProps } from "../../contexts/getGlobalTemplateProps.js";
	import translations from "./WeAreRoasterySection.translations.json" with { type: "json" };

	const { tenant } = getGlobalTemplateProps();
	const translate = getTranslate(translations);
</script>

<section class={["md:grid-container full-width py-23.5 overflow-hidden bg-fcrbeige"]}>
	<div class={["grid grid-cols-1 md:grid-cols-2 items-center flex-col px-4 md:px-0 gap-10 md:gap-15 lg:gap-38"]}>
		<div class="flex flex-col justify-between h-full md:order-2 gap-8">
			<div class="flex flex-col gap-8 lg:pt-8">
				<div class="text-black font-antipol font-bold text-6/tighter">
					<Formatted text={translate("header")} />
				</div>
				<div class="grow">
					<Formatted text={translate("content")} />
				</div>
			</div>
			<div class="flex justify-center my-4 md:my-0 md:justify-start">
				<Link
					size={ButtonSize.Medium}
					variant={ButtonVariant.White}
					href={getCategoryPath(tenant.locale, CategoryType.Coffee)}
				>
					<Formatted text={translate("cta")} />
				</Link>
			</div>
		</div>
		<div class="flex items-center justify-center md:order-1">
			<div class={["relative grow-0 shrink-0 w-150 max-w-full"]}>
				<Media
					source={{ type: "webp", src: imageRobotXs }}
					sourcesets={{
						">sm": imageRobotSm,
						">md": imageRobotMd,
						">lg": imageRobotLg,
						">xl": imageRobotXl,
						">2xl": imageRobot2Xl,
					}}
					alt={translate("imageAlt")}
					width={600}
					height={400}
					class="object-cover inset-0"
				/>
			</div>
		</div>
	</div>
</section>
